import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

let mm

export const jargonBuster = () => {

	if (mm) mm.revert()

	let rows = document.querySelectorAll('[data-animation="jargon-buster"] .term-row')

	if (!rows.length) return

	mm = gsap.matchMedia()

	mm.add({
		motion: '(prefers-reduced-motion: no-preference)',
		reduce: '(prefers-reduced-motion: reduce)',
	}, context => {

		let { motion } = context.conditions

		let splits = [...rows].map(row => {

			let term = row.querySelector('.term-text'),
				arrow = row.querySelector('.arrow'),
				meaning = row.querySelector('.meaning-text')

			return SplitText.create(term, {
				type: 'lines',
				linesClass: 'term-line',
				autoSplit: true,
				onSplit: self => {

					if (!motion) return

					return gsap.timeline({
						defaults: { ease: 'power1.out' },
						scrollTrigger: {
							trigger: row,
							start: 'top 90%',
							end: 'top 55%',
							scrub: 1,
						},
					})
						.fromTo(term, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: 0.6 })
						.fromTo(self.lines, { '--strike': 0 }, { '--strike': 1, duration: 1, ease: 'none', stagger: 0.5 })
						.fromTo(arrow, { autoAlpha: 0, x: -16 }, { autoAlpha: 1, x: 0, duration: 0.5 })
						.fromTo(meaning, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: 0.6 }, '<0.2')
				},
			})
		})

		return () => splits.forEach(split => split.revert())
	})
}

export default () => { }
